import { Typography, Stack, Button, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next';
import i18next from 'i18next'
import { useNavigate } from 'react-router-dom'

import ChipStatus from 'packages/ui/ChipStatus'

import { STATUS } from '../../constants'

export const Status = ({project}) => {
  const {t } = useTranslation()
  return (
    <ChipStatus 
      status={t(`projects.table.status.${project.state}`)}
      color={STATUS[project.state]?.color || STATUS.standby.color}
      bgcolor={STATUS[project.state]?.bgcolor || STATUS.standby.bgcolor}
      height={24}
      borderRadius="50px"
    />
  )
}

const Services = ({project}) => {
  const {t} = useTranslation()
  if (project.services.length === 0) {
    return <Typography component={'span'} sx={{fontSize: 12}}>-</Typography>
  }
  return (
    <Stack>
      {
        project.services.map((service, i) => (
          <Stack direction={'row'} justifyContent={'space-between'} key={i} gap={3}>
            <Typography component={'span'} sx={{fontSize: 12}}>{t(`projects.services.name.${service.name}`)}</Typography>
            <Tooltip title={t(`projects.services.kind.${service.kind}.tooltip`)} placement={'top'} arrow>
              <Typography component={'span'} sx={{fontSize: 12}}>{t(`projects.services.kind.${service.kind}.name`)}</Typography>
            </Tooltip>
          </Stack>
        ))
      }
    </Stack>
  )
}

const Actions = ({project}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  return (
    <Stack direction={'row'}>
      <Button variant={'outlined'} size={'small'} onClick={() => navigate(`/projects/${project.id}`)}>{t('projects.table.detail')}</Button>
    </Stack>
  )
}

const COLUMNS_CONFIG = [
  {
    name: 'status',
    header: {
      label: ctx => ctx.t('projects.table.status_col')
    },
    value: project => <Status project={project} />
  },
  {
    name: 'site',
    header: {
      label: ctx => ctx.t('projects.table.site_col')
    },
    value: project => <Typography component={'span'} sx={{fontSize: 12, fontWeight: 500}}>{project.site.name}</Typography>
  },
  {
    name: 'services',
    header: {
      label: ctx => ctx.t('projects.table.services_col'),
    },
    value: project => <Services project={project} />
  },
  {
    name: 'created_at',
    header: {
      label: ctx => ctx.t('projects.table.created_at_col')
    },
    value: project => new Date(project.created_at).toLocaleDateString(i18next.language),
    sortBy: 'created_at',
    sortable: true
  },
  {
    name: 'actions',
    header: {
      label: () => null
    },
    value: project => <Actions project={project} />
  }
]

export default COLUMNS_CONFIG